/* eslint-disable */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Carousel } from 'antd-mobile'
import './index.scss'
import "newcar-ui/output/index.css";


const CommonList = (props) => {
    const { data: { list, bossDemeanor }, pageCount } = props
    const isDoubleCol = useMemo(() => list?.length >= 6, [list])
    const [noMore, setNoMore] = useState(false)
    const total = useMemo(() => list?.length, [list])
    const [showData, setShowData] = useState([])
    const [currIndex, setCurrIndex] = useState(pageCount) // 当前数据是几个

    useEffect(() => {
        const defaultList = list.slice(0, pageCount)
        if (list.length <= pageCount) {
            setNoMore(true)
        }
        setShowData(defaultList)
        // console.log(list, noMore, showData)
    }, [])

    const loadMoreFun = useCallback(() => {
        const end = currIndex + pageCount;
        const nextPages = list.slice(currIndex, end);
        if (total - end <= 0) {
            setNoMore(true)
        }
        setShowData(showData.concat(nextPages))
        setCurrIndex(end)
    }, [showData])

    const onItemClick = useCallback((item) => {
        if (typeof props.onItemClick !== 'undefined') {
            props.onItemClick(item)
        }
    }, [])

    return (
        <>
            {
                bossDemeanor?.length > 0 && <Carousel
                    autoplay={true} infinite className="boss-swiper"
                >
                    {
                        bossDemeanor.map((item, index) => {
                            return (<div key={index}>
                                <div className='swiper-item'>
                                    <div className='swiper-item-title'>{item.title}</div>
                                    <img src={item.pic} className='swiper-item-pic' />
                                    <div className='swiper-item-index'>0{index + 1}</div>
                                </div>
                            </div>)
                        })
                    }
                </Carousel>
            }
            <div className={`${isDoubleCol ? 'doubleflow' : 'singlelist'}`}>
                {
                    showData?.map((item, index) => {
                        return (
                            <div className='list-item' key={index} onClick={() => { onItemClick(item) }}>
                                <img className="list-item-cover" src={item?.pic} />
                                <div className='list-item-content'>
                                    <div className={`list-item-content-title ${item.title.length >= 20 ? 'textEllipsis' : ''}`}>{item?.title}</div>
                                    {/* <div className='item-description'>{item?.desc}</div> */}
                                </div>
                            </div>
                        )
                    })}
            </div>
            {
                noMore ? <div className="nomore">更多内容，敬请期待!</div> :
                    <div className='showmore' onClick={loadMoreFun}>
                        查看更多
                    </div>
            }
        </>
    )
}
export default CommonList;
